import ControlButton from '../controlButton.js';

import * as btnStyles from '../btn.module.scss';

import config from '../../../gameConfig.js';

const { ROUNDS_NUMBER } = config;

export default class RepeatBtn extends ControlButton {
  constructor() {
    super({ text: 'REPEAT THE SEQUENCE' });

    this.addClasses(btnStyles.btnHidden);
    this.addListener('mouseup', this.handleRepeatSequence.bind(this));
    window.addEventListener('changestart', this.handleChangeStart.bind(this));
    window.addEventListener('changeinput', this.handleChangeInput.bind(this));
    window.addEventListener('changerepeat', this.handleChangeRepeat.bind(this));
  }

  /**
   * Sets the state's repeat property.
   * @returns {void}
   * @private
   */
  handleRepeatSequence() {
    if (this.isPressed && !this.state.block && this.state.repeat) {
      this.state.repeat = false;
    }
  }

  /**
   * Handles changes in the state's start property.
   * @param {CustomEvent<Partial<StateObj>>} e
   * @returns {void}
   * @private
   */
  handleChangeStart(e) {
    const { start } = e.detail;
    if (start) {
      this.removeClasses(btnStyles.btnHidden);
    } else {
      this.addClasses(btnStyles.btnHidden);
    }
  }

  /**
   * Handles changes in the state's input property.
   * @param {CustomEvent<StateObj>} e
   * @returns {void}
   * @private
   */
  handleChangeInput(e) {
    const { input } = e.detail;
    const { start, round, sequence, sequenceIndex } = this.state;

    const isRoundComplete =
      input.length > 0 && sequenceIndex === sequence.length;
    const isRoundLast = round === ROUNDS_NUMBER;

    if (isRoundComplete && !isRoundLast) {
      this.addClasses(btnStyles.btnHidden);
    } else if (start) {
      this.removeClasses(btnStyles.btnHidden);
    }
  }

  /**
   * Handles changes in the state's repeat property.
   * @param {CustomEvent<StateObj>} e
   * @returns {void}
   * @private
   */
  handleChangeRepeat(e) {
    const { repeat } = e.detail;

    if (repeat) {
      this.removeClasses(btnStyles.btnBlocked);
    } else {
      this.addClasses(btnStyles.btnBlocked);
    }
  }

  /**
   * Handles changes in the state's block property.
   * @param {CustomEvent<StateObj>} e
   * @returns {void}
   * @override
   * @protected
   */
  handleChangeBlock(e) {
    const { block } = e.detail;

    if (block) {
      this.addClasses(btnStyles.btnBlocked);
    } else if (this.state.repeat) {
      this.removeClasses(btnStyles.btnBlocked);
    }
  }
}
